import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

interface LoyaltyMessageProps {
  loyaltyEarnIcon?: any;
  loyaltyBaseEarnAccessibilityMessage?: any;
  loyaltyBaseEarnMessage?: any;
}

export const LoyaltyMessage: React.FunctionComponent<LoyaltyMessageProps> = ({
  loyaltyEarnIcon,
  loyaltyBaseEarnAccessibilityMessage,
  loyaltyBaseEarnMessage
}) => {
  if (!loyaltyBaseEarnMessage) {
    return null;
  }

  return (
    <ErrorBoundary label="hotel.search.listing.baseEarn">
      <div data-stid="hsr_loyalty_base_earn" className="listing__baseearn uitk-grid uitk-type-300">
        {loyaltyEarnIcon && (
          <UitkIcon name={loyaltyEarnIcon} className="uitk-cell all-cell-shrink all-r-padding-two" size={UitkIconSize.SMALL} />
        )}
        {loyaltyBaseEarnAccessibilityMessage && <span className="is-visually-hidden">{loyaltyBaseEarnAccessibilityMessage}</span>}
        <span
          aria-hidden={Boolean(loyaltyBaseEarnAccessibilityMessage)}
          className="pwa-theme--loyalty"
          dangerouslySetInnerHTML={{ __html: loyaltyBaseEarnMessage }}
        />
      </div>
    </ErrorBoundary>
  );
};
